import { render, staticRenderFns } from "./DigitizedFormComponent.vue?vue&type=template&id=624da41f&"
import script from "./DigitizedFormComponent.vue?vue&type=script&lang=js&"
export * from "./DigitizedFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports